import { useSelector } from 'react-redux';
import { WebAuthnStatus } from './actionCreators';
import { useJspVariables } from '../hooks';
import { getLabelFromJspVariables } from '../common/JspUtil';
import { IceIcon, PageHeader, TextInput } from '../components';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';

/**
 * Pure presentational body for Passkey/WebAuthn registration.
 * State + action buttons are managed by the parent (PageWebAuthnRegister for the
 * standalone route; PageTfaRegister when used inside the Setup Passkey dialog).
 */
const PageWebAuthnRegisterBody = ({
    deviceName,
    onDeviceNameChange,
    fieldErrors = {},
    startRegistration,
}) => {
    const { launcher } = useJspVariables();
    const webAuthnRegistration = useSelector(state => state.tfaReducer.tfaStatus.webAuthnRegistration);
    const tfaError = useSelector(state => state.tfaReducer.tfaError);

    return (
        <Box sx={{ position: 'relative', px: '1.125rem' }}>
            <IceIcon launcher={launcher} />
            <PageHeader dataAutomationId="webauthn_register_header">{getLabelFromJspVariables('title_register_passkey')}</PageHeader>
            {tfaError && <Alert severity="error" sx={{ mb: 1 }}>{tfaError.message}</Alert>}
            {startRegistration ?
                <Box>
                    {webAuthnRegistration === WebAuthnStatus.SUCCESS &&
                        <Alert severity="success" aria-live="polite" sx={{ mb: 2, width: '100%' }}>
                            {getLabelFromJspVariables('status_passkey_registered')}
                        </Alert>
                    }
                    {webAuthnRegistration === WebAuthnStatus.PROCESSING &&
                        <Alert severity="info" aria-live="polite" sx={{ width: '100%' }}>
                            {getLabelFromJspVariables('note_follow_screen_register')}
                        </Alert>
                    }
                    {webAuthnRegistration === WebAuthnStatus.FAILED &&
                        <Alert severity="error" sx={{ width: '100%' }}>
                            {getLabelFromJspVariables('err_passkey_register_failed')}
                        </Alert>
                    }
                </Box>
                :
                <Box>
                    <TextInput
                        id="webauthn_device_name"
                        label={getLabelFromJspVariables('label_passkey_name')}
                        name="deviceName"
                        required
                        error={!!fieldErrors.deviceName}
                        helperText={fieldErrors.deviceName}
                        value={deviceName}
                        onChange={e => onDeviceNameChange(e.target.value)}
                    />
                </Box>
            }
        </Box>
    );
};

export default PageWebAuthnRegisterBody;
